<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-6 text-sm-right">
                        <button type="button"
                            class="btn btn-sm btn-success waves-effect"
                            (click)="openModal()"><i
                                class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                    </div>
                </div>
            </div>

            
            
            <div class="container card-body table-responsive">
                <form [formGroup]="formSelectCatalogo">
                    <div class="form-floating mb-3">
                        <select class="form-select"
                            formControlName="spr_idSprEspecialUno"
                            (change)="cargarCatalogoDependiente($event.target)">
                            <option [value]="0" selected>Seleccionar catálogo</option>
                            <option *ngFor="let row of fathers"
                                [value]="row.idSprEspecialUno">
                                {{row.nombre}}
                            </option>
                        </select>
                    </div>
                </form>
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                    class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Nombre</th>
                            <th>Descripción</th>
                            <th>Ponderación</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let row of dataViewTable; let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{row.nombre}}</td>
                            <td>{{row.descripcion}}</td>
                            <td>{{row.ponderacion}}</td>
                            <td>{{((row.estado == '1')? 'Activo': 'Inactivo')}}</td>
                            <td class="text-center">
                                <div class="row">
                                <button type="button" tooltip="Editar"
                                    class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                    title="Editar este registro"
                                    (click)="edit(row)">
                                    <i class="fas fa-pencil-alt fa-lg"></i>
                                </button>
                                <button type="button"
                                    class="btn btn-sm btn-link waves-effect col px-0"
                                    title="Eliminar este registro"
                                    (click)="delete(row.idSprEspecialUno)">
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                </button>
                            </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-especialUno" [isDelete]="true"
    (confirmation)="confirmDelete()"></jw-modal>

<jw-modal id="{{nameModal}}">
    <!-- MODAL PARA CREAR Y EDITAR -->
    <div class="modal-dialog" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="modal.close();"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <form class="needs-validation" novalidate id="formEspecialUno" [formGroup]="formEspecialUno">
                    <div class="row">
                        <input type="hidden" id="idSprEspecialUno"
                            formControlName="idSprEspecialUno">

                        <div class="form-floating mb-3">

                            <input type="hidden" id="spr_idSprEspecialUno"
                                formControlName="spr_idSprEspecialUno">
                  
                                <input *ngIf="nombrePadre != null" id="nombrePadre"
                                class="form-control"
                                formControlName="nombrePadre"
                                
                                readonly>


                        </div>

                                <div class="form-floating mb-3">
                                <input id="idSprEspecialUno" type="text" class="form-control" required="true"
                                formControlName="nombre" oninput="this.value = this.value.toUpperCase();" [ngClass]="{
                                  'is-invalid': this.formEspecialUno.get('nombre')?.errors && this.submitted,
                                  'is-valid': !this.formEspecialUno.get('nombre')?.errors,
                                }" />
                              <small class="invalid-feedback"
                                *ngIf="this.formEspecialUno.get('nombre')?.errors?.['required'] && this.submitted">
                                    Campo requerido</small>
                                    <label for="formEspecialUno" class="col-form-label text-md-right"><b>Nombre</b>
                                    </label>
                            </div>


                            <div class="form-floating mb-3">
                                <textarea maxlength="1000" type="text" id="descripcion" class="form-control"
                                    formControlName="descripcion"  autofocus placeholder="descripcion"
                                    [ngClass]="{'is-valid': !!this.formEspecialUno.value.descripcion
                                      }" ></textarea>
                                <label for="descripcion">Descripción</label>
                            </div>
                        <div class="form-floating mb-3">
                            <input *ngIf="nombrePadre != null" type="number"  required="true" min="0" max="100" maxlength="3" onkeydown="return false" name="ponderacion" id="ponderacion" placeholder="Solo caracteres numericos" class="form-control" required autocomplete="off" onkeypress="return
                            (event.charCode>= 48 && event.charCode <= 57)"
                                formControlName="ponderacion"
                                required autofocus placeholder="ponderacion"
                                [ngClass]="{'ng-invalid ng-dirty' : submitted &&
                            rolForm['ponderacion'].errors}">
                            <small class="invalid-feedback" *ngIf="submitted &&
                                rolForm['ponderacion'].errors">Campo
                                requerido</small>
                            <label *ngIf="nombrePadre != null" for="ponderacion">Ponderación 
                            </label>
                           
                          
                        </div>

                        <div class="form-floating mb-3">
                            <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{
                                'is-invalid': this.formEspecialUno.get('estado')?.errors && this.submitted,
                                'is-valid': !this.formEspecialUno.get('estado')?.errors,
                              }">
                                <option value="1" selected>Activo</option>
                                <option value="2">Inactivo</option>
                              </select>
                              <label for="estado">Estado</label>
                              <small class="invalid-feedback"
                                *ngIf="this.formEspecialUno.get('estado')?.errors?.['required'] && this.submitted"> Campo
                                requerido</small>
                            </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect"
                    (click)="modal.close();">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>